import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Col, Divider, Result, Row, Spin, Typography } from "antd";
import moment from "moment/moment";
import { doGetAllInvoices } from "stores/slices/invoice";
import { setHeaderTitle } from "stores/slices/layout";
import { doCreatePayment, isSaving } from "stores/slices/payment";
import {
  doGetSubscriptionDetail,
  doGetUseSubscription,
  getCurrentSubscription,
} from "stores/slices/subscriptions";

import AppButton from "components/button";

import ModalForm from "../../../components/forms/components/modalForm";
import { getMe } from "../../../stores/slices/auth";
import {
  getWorkspaceInfo,
  WorkspaceInfo,
} from "../../../stores/slices/workspace";

const Payment = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const workspaceDetail = useSelector(WorkspaceInfo);
  const currentSubscription = useSelector(getCurrentSubscription);
  const loading = useSelector(isSaving);
  const [newSubscription, setNewSubscription] = useState({});
  const [objectPrice, setObjectPrice] = useState({});
  const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);
  const [isCalculate, setIsCalculate] = useState(true);
  const [isShowConfirmPopup, setIsShowConfirmPopup] = useState(false);
  const [isUpGrade, setIsUpGrade] = useState(false);
  const [isDownGrade, setIsDownGrade] = useState(false);
  const [currentInvoice, setCurrentInvoice] = useState([]);

  useEffect(() => {
    if (location.state && location.state.workspaceId) {
      handleGetWorkspaceDetail(location.state.workspaceId);
      dispatch(doGetUseSubscription(location.state.workspaceId));
    }
  }, []);

  useEffect(() => {
    if (newSubscription && workspaceDetail) {
      if (newSubscription?.monthlyFee && workspaceDetail?.subscriptionPackage) {
        if (
          newSubscription?.monthlyFee >
          workspaceDetail?.subscriptionPackage?.monthlyFee
        ) {
          setIsUpGrade(true);
          setIsDownGrade(false);
        } else {
          setIsUpGrade(false);
          setIsDownGrade(true);
        }
      } else {
        if (newSubscription?.monthlyFee === 0) {
          setIsUpGrade(false);
          setIsDownGrade(true);
        }
      }
    }
  }, [newSubscription, workspaceDetail]);

  useEffect(() => {
    if (workspaceDetail && workspaceDetail?.id) {
      if (location.state && location.state.workspaceId) {
        handleGetCurrentInvoice(location.state.workspaceId);
      } else {
        handleGetCurrentInvoice(workspaceDetail?.id);
      }
    }
  }, [workspaceDetail]);

  const handleGetCurrentInvoice = async workspaceId => {
    const { payload } = await dispatch(doGetAllInvoices(workspaceId));
    // console.log("payload", payload);
    if (payload && payload?.data) {
      if (payload?.data && payload?.data?.length > 0) {
        setCurrentInvoice(payload?.data);
      } else {
        setCurrentInvoice([]);
      }
    }
  };

  const handleGetWorkspaceDetail = async workspaceId => {
    await dispatch(getWorkspaceInfo(workspaceId));
  };

  const calculateTotalPrice = () => {
    const now = moment().utc();
    const startDate = moment(currentSubscription?.startTime).utc();
    const endDate = moment(currentSubscription?.endTime).utc();
    const currentTotalDays = moment(endDate).diff(moment(startDate), "days");
    let remainingDays = moment(endDate).diff(moment(now), "days");

    // totaldaythismonth: currentTotalDays
    // until days: remainingDays
    // used days: currentTotaldays - remainingdays
    // include service: free service (newSubscription?.numberInc)
    // over service: currentSubscription?.currentNumberOfAddress - newSubscription?.numberInc;
    // costNumberPerUnit: newSubscription?.numberFee
    // cost service: costNumberPerUnit / currentTotaldays * (currentTotaldays - remainingdays) * overService;
    // include seat: freeseat (newSubscription?.perSeatInc)
    // over seat: currentSubscription?.currentNumberOfUser - newSubscription?.perSeatInc;
    // costSeatPerUnit: newSubscription?.perSeatFee
    // cost seat: costSeatPerUnit / currentTotaldays * (currentTotaldays - remainingdays) * overSeat;
    //   const costMonthlyPerUnit =
    //   currentTotalDays !== remainingDays
    //     ? newSubscription?.monthlyFee / currentTotalDays
    //     : newSubscription?.monthlyFee;
    // const costMonthlyTotal =
    //   currentTotalDays === remainingDays
    //     ? costMonthlyPerUnit
    //     : costMonthlyPerUnit?.toFixed(2) * remainingDays;
    // costProratedTotal = costDaySinceLastRenewal + costDaysUntilNextRenewal + costExtraServices + costExtraSeats;
    // costPreviousSubscription => get newest invoice
    // costUpgrade = costProratedTotal - costPreviousSubscription
    // gst = costUpgrade * 0.1
    // totalFee = costUpgrade + gst
    if (
      now.startOf("date").diff(startDate.startOf("date")) === 0 ||
      remainingDays === 0
    ) {
      remainingDays = currentTotalDays;
    }

    const untilDays = remainingDays;
    const usedDays = currentTotalDays - remainingDays;

    const freeSeat = newSubscription?.perSeatInc;

    let overSeat =
      currentSubscription?.currentNumberOfUser - newSubscription?.perSeatInc;
    overSeat = overSeat > 0 ? overSeat : 0;
    // console.log("overSeat", overSeat);

    const costSeatPerUnit = newSubscription?.perSeatFee;

    const costSeatTotal = isDownGrade
      ? costSeatPerUnit * overSeat
      : (costSeatPerUnit / currentTotalDays) * remainingDays * overSeat;

    const freeService = newSubscription?.numberInc;

    let overService =
      currentSubscription?.currentNumberOfAddress - newSubscription?.numberInc;
    overService = overService > 0 ? overService : 0;
    // console.log("overService", overService);
    const costNumberPerUnit = newSubscription?.numberFee;
    // console.log("newSub", newSubscription);
    const costNumberTotal = isDownGrade
      ? costNumberPerUnit * overService
      : (costNumberPerUnit / currentTotalDays) * remainingDays * overService;

    // previous subscription
    const costMonthlyPerUnit = isDownGrade
      ? newSubscription?.monthlyFee
      : workspaceDetail?.subscriptionPackage?.monthlyFee;

    const costMonthlyTotal =
      currentTotalDays - remainingDays === 0
        ? isDownGrade
          ? newSubscription?.monthlyFee
          : costMonthlyPerUnit
        : isDownGrade
        ? newSubscription?.monthlyFee
        : (costMonthlyPerUnit / currentTotalDays) *
          (currentTotalDays - remainingDays);

    const total = costMonthlyTotal + costSeatTotal + costNumberTotal;
    let subPrevious = 0;
    if (currentInvoice && currentInvoice.length > 0) {
      // console.log("currentInvoice", currentInvoice);
      currentInvoice?.map(item => {
        subPrevious = subPrevious + item.amountWithOutTax;
      });
    }

    const previousTotal = subPrevious > 0 ? subPrevious : 0;

    const costUsedDays =
      (costMonthlyPerUnit / currentTotalDays) *
      (currentTotalDays - remainingDays);
    const costNext = newSubscription?.monthlyFee;
    const costUntilDays = (costNext / currentTotalDays) * remainingDays;

    const costProrated = isUpGrade
      ? Number(costUsedDays.toFixed(2)) +
        Number(costUntilDays.toFixed(2)) +
        Number(costSeatTotal.toFixed(2)) +
        Number(costNumberTotal.toFixed(2))
      : Number(costMonthlyTotal.toFixed(2)) +
        Number(costSeatTotal.toFixed(2)) +
        Number(costNumberTotal.toFixed(2));
    const costUpgrade = isUpGrade ? costProrated - previousTotal : total;

    const gst = isUpGrade
      ? costUpgrade.toFixed(2) * 0.1
      : total?.toFixed(2) * 0.1;

    const totalFee = isUpGrade ? costUpgrade + gst : total + gst;

    setObjectPrice({
      currentTotalDays: currentTotalDays,
      remainingDays: remainingDays,
      usedDays: usedDays,
      untilDays: untilDays,
      freeSeat: freeSeat,
      overSeat: overSeat,
      freeService: freeService,
      overService: overService,
      costNumberPerUnit: costNumberPerUnit,
      costNumberTotal: costNumberTotal,
      costSeatPerUnit: costSeatPerUnit,
      costSeatTotal: costSeatTotal,
      costMonthlyPerUnit: costMonthlyPerUnit,
      costNext: costNext,
      costMonthlyTotal: costMonthlyTotal,
      costUsedDays: costUsedDays,
      costUntilDays: costUntilDays,
      total: total,
      costUpgrade: costUpgrade,
      gst: gst,
      previousTotal: previousTotal,
      costProrated: costProrated,
      adjustedTotal: costUpgrade + costProrated,
      totalFee: totalFee > 0 ? totalFee : 0,
    });
    return true;
  };
  // console.log("current", currentSubscription);
  // console.log("new", newSubscription);
  // console.log("object", objectPrice);
  const doCheckOut = async () => {
    if (
      !workspaceDetail?.payment &&
      newSubscription.monthlyFee !== 0 &&
      newSubscription.numberFee !== 0 &&
      newSubscription.perSeatFee !== 0
    ) {
      if (location?.state && location?.state?.workspaceId) {
        navigate(`/admin/add-card/${id}`, {
          state: {
            workspaceId: location?.state?.workspaceId,
          },
        });
      } else {
        navigate(`/admin/add-card/${id}`);
      }
    } else {
      if (isDownGrade) {
        // setIsOpenModalWarning(true);
        doPaymentPackage();
      } else {
        setIsShowConfirmPopup(true);
      }
    }
  };

  const doPaymentPackage = async () => {
    if (id) {
      const request = {
        subscriptionPackageId: id,
      };
      if (location.state && location.state.workspaceId) {
        request.workspaceId = location.state.workspaceId;
      }
      const { payload } = await dispatch(doCreatePayment(request));
      if (payload && payload.status === 200) {
        setIsShowConfirmPopup(false);
        setIsPaymentSuccess(true);
        await dispatch(getMe());
      } else {
        if (payload.data === "MISSING_CARD") {
          navigate(`/admin/add-card/${id}`);
        }
        setIsShowConfirmPopup(false);
      }
    }
  };

  useEffect(() => {
    if (id) {
      loadSubscriptionDetail();
      if (!location?.state) {
        dispatch(doGetUseSubscription());
      }
    }
    dispatch(setHeaderTitle("payments"));
  }, []);

  const loadSubscriptionDetail = async () => {
    const { payload } = await dispatch(doGetSubscriptionDetail(id));
    if (payload) {
      setNewSubscription(payload);
    }
  };

  useEffect(() => {
    setObjectPrice({});
    if (
      newSubscription?.id &&
      currentSubscription?.workspaceId &&
      typeof currentInvoice !== "string" &&
      (isUpGrade || isDownGrade)
    ) {
      const calculate = calculateTotalPrice();
      if (calculate) {
        setIsCalculate(false);
      }
    }
  }, [
    newSubscription,
    currentSubscription,
    isUpGrade,
    isDownGrade,
    currentInvoice,
  ]);

  const checkPayment = () => {
    if (newSubscription?.monthlyFee && workspaceDetail?.subscriptionPackage) {
      if (
        newSubscription?.monthlyFee >
        workspaceDetail?.subscriptionPackage?.monthlyFee
      ) {
        setIsUpGrade(true);
        setIsDownGrade(false);
      } else {
        setIsUpGrade(false);
        setIsDownGrade(true);
      }
    }
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {isCalculate && (
        <div style={{ marginTop: "30px" }}>
          <Spin size="large" />
        </div>
      )}
      {!isCalculate && !isPaymentSuccess && (
        <div
          style={{
            width: "800px",
            marginTop: "20px",
          }}
        >
          <Typography.Title level={2}>{t("payment.checkout")}</Typography.Title>
          <Typography.Text style={{ fontSize: "20px", marginRight: "8px" }}>
            {t("payment.subscriptionPackage")}:
          </Typography.Text>
          <Typography.Text style={{ fontSize: "20px" }} strong>
            {newSubscription?.name}
          </Typography.Text>

          <Row gutter={[20, 8]} style={{ marginTop: "20px" }}>
            <Col span={8}>
              <Typography.Text strong>{t("payment.items")}</Typography.Text>
            </Col>
            <Col span={3} style={paymentStyle.textAlignRight}>
              <Typography.Text strong>{t("payment.quantity")}</Typography.Text>
            </Col>
            <Col span={3}>
              <Typography.Text strong>{t("payment.unit")}</Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text strong>{t("payment.price")}</Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text strong>{t("payment.subtotal")}</Typography.Text>
            </Col>
          </Row>
          <Divider style={{ margin: "8px 0" }} />
          <Row gutter={[20, 8]}>
            {/* Monthly fee */}
            {!isUpGrade && (
              <>
                <Col span={8}>
                  <Typography.Text strong>
                    {t("payment.monthlyFee")}
                  </Typography.Text>
                </Col>
                <Col span={3} style={paymentStyle.textAlignRight}>
                  <Typography.Text>{"1"}</Typography.Text>
                </Col>
                <Col span={3}>
                  <Typography.Text>
                    {t("payment.month").toLowerCase()}
                  </Typography.Text>
                </Col>
                <Col span={5} style={paymentStyle.textAlignRight}>
                  <Typography.Text>
                    {objectPrice.costMonthlyPerUnit?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
                  </Typography.Text>
                </Col>
                <Col span={5} style={paymentStyle.textAlignRight}>
                  <Typography.Text>
                    {objectPrice?.costMonthlyTotal?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
                  </Typography.Text>
                </Col>
              </>
            )}
            {isUpGrade && (
              <>
                <Col span={8}>
                  <Typography.Text strong>
                    {t("payment.daysSinceLastRenewal")}
                  </Typography.Text>
                </Col>
                <Col span={3} style={paymentStyle.textAlignRight}>
                  <Typography.Text>
                    {objectPrice.currentTotalDays - objectPrice.remainingDays}
                  </Typography.Text>
                </Col>
                <Col span={3}>
                  <Typography.Text>
                    {objectPrice.currentTotalDays - objectPrice.remainingDays >
                    1
                      ? t("payment.days").toLowerCase()
                      : t("payment.day").toLowerCase()}
                  </Typography.Text>
                </Col>
                <Col span={5} style={paymentStyle.textAlignRight}>
                  <Typography.Text>
                    {!objectPrice?.costMonthlyPerUnit
                      ? "-"
                      : objectPrice?.costMonthlyPerUnit?.toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                            style: "currency",
                            currency: "USD",
                          }
                        )}
                  </Typography.Text>
                </Col>
                <Col span={5} style={paymentStyle.textAlignRight}>
                  <Typography.Text>
                    {objectPrice?.costUsedDays?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
                  </Typography.Text>
                </Col>
                {/* days until next renewal */}
                <Col span={8}>
                  <Typography.Text strong>
                    {t("payment.daysUntilNextRenewal")}
                  </Typography.Text>
                </Col>
                <Col span={3} style={paymentStyle.textAlignRight}>
                  <Typography.Text>{objectPrice.remainingDays}</Typography.Text>
                </Col>
                <Col span={3}>
                  <Typography.Text>
                    {objectPrice.remainingDays > 1
                      ? t("payment.days").toLowerCase()
                      : t("payment.day").toLowerCase()}
                  </Typography.Text>
                </Col>
                <Col span={5} style={paymentStyle.textAlignRight}>
                  <Typography.Text>
                    {!objectPrice?.costNext
                      ? "-"
                      : objectPrice?.costNext?.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          style: "currency",
                          currency: "USD",
                        })}
                  </Typography.Text>
                </Col>
                <Col span={5} style={paymentStyle.textAlignRight}>
                  <Typography.Text>
                    {objectPrice?.costUntilDays?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
                  </Typography.Text>
                </Col>
              </>
            )}

            {/* Included contact */}
            <Col span={8}>
              <Typography.Text strong>
                {t("payment.noContacts")}
              </Typography.Text>
            </Col>
            <Col span={3} style={paymentStyle.textAlignRight}>
              <Typography.Text>
                {newSubscription?.numberContact?.toLocaleString()}
              </Typography.Text>
            </Col>
            <Col span={3}>
              <Typography.Text>
                {newSubscription?.numberContact?.toLocaleString() <= 1
                  ? t("payment.contact")
                  : t("payment.contacts")}
              </Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text>-</Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text>-</Typography.Text>
            </Col>

            {/* # of free services */}
            <Col span={8}>
              <Typography.Text strong>{t("payment.noNumbers")}</Typography.Text>
            </Col>
            <Col span={3} style={paymentStyle.textAlignRight}>
              <Typography.Text>
                {objectPrice?.freeService?.toLocaleString()}
              </Typography.Text>
            </Col>
            <Col span={3}>
              <Typography.Text>
                {objectPrice?.freeService?.toLocaleString() <= 1
                  ? t("payment.service")
                  : t("payment.services")}
              </Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text>-</Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text>-</Typography.Text>
            </Col>

            {/* # of extra services */}
            <Col span={8}>
              <Typography.Text strong>
                {t("payment.noExtraNumbers")}
              </Typography.Text>
            </Col>
            <Col span={3} style={paymentStyle.textAlignRight}>
              <Typography.Text>
                {objectPrice?.overService?.toLocaleString()}
              </Typography.Text>
            </Col>
            <Col span={3}>
              <Typography.Text>
                {objectPrice?.overService?.toLocaleString() <= 1
                  ? t("payment.service")
                  : t("payment.services")}
              </Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text>
                {objectPrice?.overService === 0
                  ? "-"
                  : objectPrice?.costNumberPerUnit?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
              </Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text>
                {Number(
                  objectPrice?.costNumberTotal?.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                ) === Number("0.00")
                  ? "-"
                  : objectPrice?.costNumberTotal?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
              </Typography.Text>
            </Col>

            {/* Include seat */}
            <Col span={8}>
              <Typography.Text strong>
                {t("payment.noFreeSeats")}
              </Typography.Text>
            </Col>
            <Col span={3} style={paymentStyle.textAlignRight}>
              <Typography.Text>
                {objectPrice?.freeSeat?.toLocaleString()}
              </Typography.Text>
            </Col>
            <Col span={3}>
              <Typography.Text>
                {objectPrice?.freeSeat?.toLocaleString() <= 1
                  ? t("payment.seat")
                  : t("payment.seats")}
              </Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text>-</Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text>-</Typography.Text>
            </Col>

            {/* Extra seat */}
            <Col span={8}>
              <Typography.Text strong>
                {t("payment.noExtraSeats")}
              </Typography.Text>
            </Col>
            <Col span={3} style={paymentStyle.textAlignRight}>
              <Typography.Text>
                {objectPrice?.overSeat?.toLocaleString()}
              </Typography.Text>
            </Col>
            <Col span={3}>
              <Typography.Text>
                {objectPrice?.overSeat?.toLocaleString() <= 1
                  ? t("payment.seat")
                  : t("payment.seats")}
              </Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text>
                {objectPrice?.overSeat === 0
                  ? "-"
                  : objectPrice?.costSeatPerUnit?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
              </Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text>
                {Number(
                  objectPrice?.costSeatTotal?.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                ) === Number("0.00")
                  ? "-"
                  : objectPrice?.costSeatTotal?.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                      style: "currency",
                      currency: "USD",
                    })}
              </Typography.Text>
            </Col>
            {isUpGrade && (
              <>
                {/* prorated total */}
                <Col span={8}>
                  <Typography.Text strong>
                    {t("payment.proratedTotal")}
                  </Typography.Text>
                </Col>
                <Col span={3} style={paymentStyle.textAlignRight}></Col>
                <Col span={3}></Col>
                <Col span={5} style={paymentStyle.textAlignRight}></Col>
                <Col span={5} style={paymentStyle.textAlignRight}>
                  <Typography.Text>
                    {Number(
                      objectPrice?.costProrated?.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ) === Number("0.00")
                      ? "-"
                      : objectPrice?.costProrated?.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          style: "currency",
                          currency: "USD",
                        })}
                  </Typography.Text>
                </Col>

                {/* credit previous subscription */}
                <Col span={8}>
                  <Typography.Text strong>
                    {t("payment.creditForPreviousSubscription")}
                  </Typography.Text>
                </Col>
                <Col span={3} style={paymentStyle.textAlignRight}></Col>
                <Col span={3}></Col>
                <Col span={5} style={paymentStyle.textAlignRight}></Col>
                <Col span={5} style={paymentStyle.textAlignRight}>
                  <Typography.Text>
                    {Number(
                      objectPrice?.previousTotal?.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ) === Number("0.00")
                      ? "-"
                      : `-${objectPrice?.previousTotal?.toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                            style: "currency",
                            currency: "USD",
                          }
                        )}`}
                  </Typography.Text>
                </Col>
                {/* upgrade cost */}
                <Col span={8}>
                  <Typography.Text strong>
                    {t("payment.upgradeCost")}
                  </Typography.Text>
                </Col>
                <Col span={3} style={paymentStyle.textAlignRight}></Col>
                <Col span={3}></Col>
                <Col span={5} style={paymentStyle.textAlignRight}></Col>
                <Col span={5} style={paymentStyle.textAlignRight}>
                  <Typography.Text>
                    {Number(
                      objectPrice?.costUpgrade?.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    ) === Number("0.00")
                      ? "-"
                      : objectPrice?.costUpgrade?.toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                          style: "currency",
                          currency: "USD",
                        })}
                  </Typography.Text>
                </Col>
              </>
            )}
          </Row>

          <Divider style={{ margin: "8px 0" }} />
          <Row
            gutter={[20, 10]}
            style={{ marginTop: "15px", alignItems: "center" }}
          >
            <Col span={19}>
              <Typography.Text style={{ fontSize: "18px" }}>
                {t("payment.gst")}
              </Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text strong>
                {objectPrice?.gst?.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                  style: "currency",
                  currency: "USD",
                })}
              </Typography.Text>
            </Col>
            <Col span={19}>
              <Typography.Text style={{ fontSize: "18px" }} strong>
                {t("payment.totalCost")}
              </Typography.Text>
            </Col>
            <Col span={5} style={paymentStyle.textAlignRight}>
              <Typography.Text strong>
                {"AUD" +
                  objectPrice?.totalFee?.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })}
              </Typography.Text>
            </Col>
            {isDownGrade && (
              <Col
                span={24}
                style={{
                  fontStyle: "italic",
                  padding: "0px 30px",
                  textAlign: "center",
                }}
              >
                <Typography.Text>
                  {`You are downgrading subscription package. The current subscription package will remain in place until the next renewal date (${moment(
                    currentSubscription?.endTime
                  )
                    .utc()
                    .format("YYYY-MM-DD")})`}
                </Typography.Text>
              </Col>
            )}
          </Row>
          <div style={{ width: "100%", textAlign: "right", marginTop: 8 }}>
            <AppButton
              label={
                !workspaceDetail?.payment &&
                newSubscription.monthlyFee !== 0 &&
                newSubscription.numberFee !== 0 &&
                newSubscription.perSeatFee !== 0
                  ? t("payment.addCard")
                  : isUpGrade
                  ? t("payment.upGrade")
                  : isDownGrade
                  ? t("payment.confirm")
                  : t("payment.payNow")
              }
              size="small"
              color={"primary"}
              type="submit"
              loading={loading}
              onClick={doCheckOut}
            />
          </div>
        </div>
      )}
      {isPaymentSuccess && (
        <Result
          status="success"
          title={
            isDownGrade
              ? t("payment.downgradeSuccessfullyTitle")
              : t("payment.purchasedSuccessfullyTitle")
          }
          subTitle={
            <span
              dangerouslySetInnerHTML={{
                __html: isDownGrade
                  ? t("payment.downgradeSuccessfully", {
                      subscriptionName: newSubscription?.name,
                    })
                  : t("payment.purchaseSuccessfully", {
                      subscriptionName: newSubscription?.name,
                    }),
              }}
            ></span>
          }
          extra={[
            <Button key="buy" onClick={() => navigate("/admin/workspaces")}>
              {t("payment.goToWorkspace")}
            </Button>,
          ]}
        />
      )}

      <ModalForm
        title={t("payment.checkout")}
        onCancel={() => {
          setIsShowConfirmPopup(false);
          checkPayment();
        }}
        destroyOnClose={true}
        isOpen={isShowConfirmPopup}
        labelSubmit={t("label.save")}
        customWidth={400}
        footer={false}
        maskClosable={false}
      >
        <Row gutter={[16, 8]}>
          <Col span={12}>{t("payment.subscriptionPackage")}</Col>
          <Col
            span={12}
            style={{ ...paymentStyle.textAlignRight, fontWeight: "bold" }}
          >
            {newSubscription.name}
          </Col>
          <Col span={12}>{t("payment.totalCost")}</Col>
          <Col
            span={12}
            style={{ ...paymentStyle.textAlignRight, fontWeight: "bold" }}
          >
            {"AUD" +
              objectPrice?.totalFee?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              })}
          </Col>
          <Col span={12}>{t("payment.card")}</Col>
          <Col
            span={12}
            style={{ ...paymentStyle.textAlignRight, fontWeight: "bold" }}
          >
            {workspaceDetail.cardHolder}
            {"  "}
            ****{workspaceDetail.stripLast4Digit}
          </Col>
        </Row>
        <div style={{ width: "100%", marginTop: 16 }}>
          <AppButton
            label={
              isDownGrade
                ? t("payment.confirm")
                : t("payment.pay") +
                  " " +
                  "AUD" +
                  objectPrice?.totalFee?.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
            }
            style={{ width: "100%" }}
            size="small"
            color={"primary"}
            type="submit"
            loading={loading}
            onClick={doPaymentPackage}
          />
        </div>
      </ModalForm>
    </div>
  );
};

const paymentStyle = {
  textAlignRight: {
    textAlign: "right",
  },
};
export default Payment;
